/*
 * Purpose : Component to download logs details as an excel file
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react';
import {NavLink} from "react-router-dom";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactHTMLTableToExcel from 'react-html-table-to-excel'; 

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  btnExport: {
    backgroundColor:"#fb8734", 
    //width:"-webkit-fill-available", 
    borderColor:"#fff", 
    boxShadow:"0px 1px 2px 2px #C0C0C0", 
    marginBottom:"2%",
    marginRight:"2%",
    color:"#fff",
    display:"inline-block",
    border:"1px solid transparent",
    borderRadius:".25rem",
    lineHeight:"2"
  },
  noDataDiv: {
    maxHeight:"400px",
    height:"270px",
    textAlign:"center",
    marginTop:"10%"
  }
});

export default function ExportExcel(props) {
  const classes = useStyles();
  //console.log(props.logData.length)
  const StyledTableCell = withStyles((theme) => ({
        head: {
          backgroundColor: "rgb(251, 135, 52)",
          color: "#fff",
        },
        body: {
          fontSize: 14,
        },
      }))(TableCell);

  let returnVal = <div className={classes.noDataDiv}>No logs are available in the specified date range</div>
  if(props.logData.length > 0){
    returnVal = <div >
        <ReactHTMLTableToExcel  
            className={classes.btnExport}
            table="log"
            filename="LogReport"
            sheet="Sheet"
            buttonText="Export excel"
            //style={{backgroundColor:"#fb8734", width:"-webkit-fill-available", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0", marginBottom:"2%"}}
        />
        <NavLink to="/dashboard" >
          <button className={classes.btnExport} style={{float:"right"}}>Go Back to Dashboard</button>
        </NavLink>
        <TableContainer component={Paper} style={{overflow:"scroll", height:"400px"}}>
          <Table className={classes.table} size="small" stickyHeader  aria-label="a dense table" id ="log">
            <TableHead style={{backgroundColor:"rgb(251, 135, 52)"}}>
              <TableRow>
                <StyledTableCell component="th"><b>Log Date(YYYY-MM-DD)</b></StyledTableCell>
                <StyledTableCell component="th" ><b>Level</b></StyledTableCell>
                <StyledTableCell component="th"><b>Message&nbsp;</b></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.logData.sort((a, b) => a.loggeddate > b.loggeddate ? -1 : b.loggeddate > a.loggeddate ? 1 : 0)
              .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {row.loggeddate}
                      </TableCell>
                      <TableCell align="left">{row.level}</TableCell>
                      <TableCell align="left">{row.message}</TableCell>
                    </TableRow>
                    )
                  )
              }
            </TableBody>
          </Table>
        </TableContainer>
    </div>
  }
  return (
    returnVal     
  );
}